import { Box } from '@mui/material';
import React, { FC, useMemo } from 'react';
import { BhiDialog } from 'src/UIKit';
import { FormView } from 'src/components/FormPart/FormView';
import { FormErrorRecord } from 'src/components/FormPart/types';
import { GroupFormDialogController } from '../../controllers';
import { GroupFormData } from '../../types';
import { GroupForm } from './GroupForm';

interface GroupFormDialogProps extends GroupFormDialogController {
  onAddContacts?: () => void;
  onEditRules?: () => void;
  allowDynamicType?: boolean;
}

export const GroupFormDialog: FC<GroupFormDialogProps> = props => {
  const {
    isOpen,
    close,
    initFormData,
    error,
    submit,
    onAddContacts,
    onEditRules,
    allowDynamicType,
  } = props;

  const errorList: FormErrorRecord<GroupFormData>[] | undefined = useMemo(() => {
    if (error?.error === 'validation' && error.message.includes('name')) {
      return [{ field: 'name', message: 'Group names must be unique' }];
    }
  }, [error]);

  return (
    <BhiDialog
      isOpen={isOpen}
      onClose={close}
      title={initFormData?.id ? 'Update Group' : 'Create Group'}
    >
      {initFormData && (
        <Box px={2.5} pb={2.5}>
          <FormView
            formData={initFormData}
            component={GroupForm}
            componentProps={{ onAddContacts, onEditRules, allowDynamicType }}
            errorList={errorList}
            onSubmit={(full, dirty) => submit(full, dirty)}
          />
        </Box>
      )}
    </BhiDialog>
  );
};
